import { Button, Dialog } from "@mui/material";
import React, { useState } from "react";
import crossGray from '../../public/assets/images/crossGray.svg'

const ModalWrapperBig = (props) => {
    const { open, onClose, children,handleClose, className } = props;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`commonModalBig ${className}`} // when using className as a prop,you have to write that class in global.scss
    >
        <Button className="cross_btn" onClick={handleClose}>
            <img src={crossGray} alt="img" width={9} height={9}/>
        </Button>
      {children}
    </Dialog>
  )
}

export default ModalWrapperBig